import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule } from '@angular/common/http'

import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppService } from './app.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './Material/material.module';
import { DeliveryInfoComponent } from './delivery-info/delivery-info.component';
import { MapComponent } from './map/map.component';
import { RouterModule } from '@angular/router';

import { APP_ROUTES } from './app.routing.module';
import {AuditSmsComponent} from "./audit/audit-sms/audit-sms.component";
import {AuditServiceService} from "./audit/audit-service.service";
import {LoggingSmsComponent} from "./audit/logging-sms/logging-sms.component";
import { Mapv2Component } from './mapv2/mapv2.component';
import { MapHeaderComponent } from './map-header/map-header.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DraggableDirective } from './draggable.directive';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    DeliveryInfoComponent,
    AuditSmsComponent,
    LoggingSmsComponent,
    Mapv2Component,
    MapHeaderComponent,
    DraggableDirective

  ],
    imports: [
        BrowserModule,
        FormsModule,
        MaterialModule,
        HttpClientModule,
        BrowserAnimationsModule,

        RouterModule.forRoot(APP_ROUTES, {
            useHash: false,
        }),
        ReactiveFormsModule,
        NgbModule,

    ],
  providers: [AppService, AuditServiceService],
  bootstrap: [AppComponent]
})
export class AppModule { }
